import { render } from "./SummaryTransactionsList.vue?vue&type=template&id=62fb3104"
import script from "./SummaryTransactionsList.vue?vue&type=script&lang=js"
export * from "./SummaryTransactionsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__